import React, { useState } from 'react';
import { ModalBody, Row, Col, Modal, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import Axios from "axios";
import { ApiConfig } from '../../../../api/apiConfig/apiConfig';
import Strip from '../../../customComponent/Strip/Strip';
import { alertDangerConfirmMessage, alertSuccessMessage } from '../../../customComponent/confirmationMessage/ConfirmationMessage';
import Loader from '../../../customComponent/Loader/Loader';
import ToolsService from '../../../../api/services/ToolsService';

const AddTool = (props) => {
    const [description, setDescription] = useState('');
    const [id, setId] = useState('');
    const [title, setTitle] = useState('');
    const [url, setUrl] = useState('');
    const [detailTitle, setDetailTitle] = useState('');
    const [isFileChanged, setIsFileChanged] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [photo, setPhoto] = useState('');
    const [photoFileName, setPhotoFileName] = useState('');
    const [photoFile, setPhotoFile] = useState('');
    const { isModal, toggle, isAdd } = props;

    React.useEffect(() => {
        if (isAdd) {
            setTitle('');
            setDetailTitle('');
            setDescription('');
            setUrl('');
            setId('');
        } else {
            setTitle(props.item.title)
            setDetailTitle(props.item.detailTitle)
            setDescription(props.item.description);
            setId(props.item.id)
            setUrl(props.item.url)
        }
        setIsFileChanged(false);
    }, [isAdd, props]);

    const handleTitle = (event) => {
        setTitle(event.target.value)
    };

    const handleDetailTitle= (event) => {
        setDetailTitle(event.target.value)
    };

    const handleDescription = (event) => {
        setDescription(event.target.value)
    }

    const handleUrl = (event) => {
        setUrl(event.target.value)
    }

    const handleSubmit = async () => {
        const userId = await localStorage.getItem('userId')
        let data = {
            title: title,
            userId: userId,
            id: id,
            description: description,
            detailTitle: detailTitle,
            url: url,
        };

        if (isFileChanged) {
            UploadImage(photoFile, data)
        } else {
            insertOrUpdate(data);
        }
    }

    const UploadImage = async (file, insertOrUpdateData) => {
        const data = await new FormData();
        await data.append("floderPath", "uploads/banner/");
        await data.append("image", file);
        setIsLoading(true);

        const config = {
            headers: {
                "content-type": "multipart/form-data",
            },
        };
        console.log('photos : ', data);
        Axios.post(`${ApiConfig.baseUrl}upload`, data, config)
            .then(async (res) => {
                if (res.status === 200) {
                    try {
                        if (res.data.code === 0) {
                            await insertOrUpdate(insertOrUpdateData);
                        } else {
                            setIsLoading(false);
                            alertDangerConfirmMessage(`${res.data.message}`);
                        }
                    } catch (err) {
                        console.log(err);
                        setIsLoading(false);
                    }
                }
            })
            .catch((err) => {
                console.log("We will be back soon.");
                return err;
            });
    };


    const insertOrUpdate = async (data) => {
        await ToolsService.insertOrUpdate(data)
            .then(async (res) => {
                if (res.status === 200) {
                    try {
                        res.text().then(async (res) => {
                            let result = JSON.parse(res);
                            if (result.code === 0) {
                                alertSuccessMessage(`${result.message}`);
                                props.handleRefresh();
                                setIsLoading(false);

                            } else {
                                setIsLoading(false);
                                alertDangerConfirmMessage(`${result.message}`);
                            }
                        });
                    } catch (err) {
                        console.log(err);
                        setIsLoading(false);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
            });
    }

    return (
        <Strip
            id="tst-add-ttol"
            className="strip strip-no-padding"
            containerType="container-fluid"
        >
            <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Modal
                        isOpen={isModal}
                        toggle={toggle}
                        className="modal-container modal-xl"
                    >
                        <div className="modal-header-container bg-dark-pink">
                            <Row className="no-margin align-items-center py-2">
                                <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                                    <p className="mb-0 p-large align-left title-white fw-blod">
                                        {isAdd ? "ADD" : "UPDATE "}
                                    </p>
                                </Col>
                                <Col
                                    xs={2}
                                    sm={2}
                                    md={2}
                                    lg={2}
                                    xl={2}
                                    className="cursor-pointer"
                                    onClick={toggle}
                                >
                                    <p className="mb-0 p-medium internal-page__title align-right title-white">close</p>
                                </Col>
                            </Row>
                        </div>
                        <ModalBody className="modal-content-container">
                            <Row>
                                <Col xs={10} sm={10} md={10} lg={6} xl={6} className="m-auto">
                                    <Row className="m-auto">
                                        <Col
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            className="pt-3 pb-5"
                                        >
                                            <Row className="mt-2">
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Form>
                                                        <FormGroup row className="mx-0 align-items-center justify-content-center">
                                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <Label className="common-label text-left">
                                                                     Title*:
                                                                </Label>
                                                                <Input
                                                                    type="text"
                                                                    placeholder="title"
                                                                    id="title"
                                                                    name="title"
                                                                    className="form-control common-form-control"
                                                                    value={title}
                                                                    onChange={(event) => handleTitle(event)}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row className="mx-0 align-items-center">
                                                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <Label className="common-label text-left">
                                                                    Detail Title*:
                                                                </Label>
                                                                <Input
                                                                    type="text"
                                                                    placeholder=" Detail title"
                                                                    id="detailtitle"
                                                                    name="detailtitle"
                                                                    className="form-control common-form-control"
                                                                    value={detailTitle}
                                                                    onChange={(event) => handleDetailTitle(event)}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row className="mx-0 align-items-center">
                                                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <Label className="common-label text-left">
                                                                    Description*:
                                                                </Label>
                                                                <Input
                                                                    type="textarea"
                                                                    placeholder="Description"
                                                                    id="description"
                                                                    name="description"
                                                                    className="form-control common-form-control"
                                                                    value={description}
                                                                    onChange={(event) => handleDescription(event)}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                        <FormGroup row className="mx-0 align-items-center">
                                                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <Label className="common-label text-left">
                                                                    Url*:
                                                                </Label>
                                                                <Input
                                                                    type="text"
                                                                    placeholder="Url"
                                                                    id="url"
                                                                    name="url"
                                                                    className="form-control common-form-control"
                                                                    value={url}
                                                                    onChange={(event) => handleUrl(event)}
                                                                    rows={10}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    </Form>
                                                </Col>
                                            </Row>
                                            <Row className="no-margin">
                                                <Col
                                                    xs={12}
                                                    sm={12}
                                                    md={{ offset: 4, size: 6 }}
                                                    lg={{ offset: 4, size: 6 }}
                                                    xl={{ offset: 4, size: 6 }}
                                                >
                                                    <Row>
                                                        <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                                            <Button
                                                                className="btn btn-block custom-danger-btn custom-btn--small br-4px"
                                                                onClick={toggle}
                                                            >
                                                                Cancel
                                                          </Button>
                                                        </Col>
                                                        <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                                            <Button

                                                                className="btn btn-block custom-theme-btn custom-btn--small br-4px"
                                                                onClick={() => handleSubmit()}
                                                            >
                                                                Submit
                                                         </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            {isLoading ? (
                                <div className="loader-position">
                                    <Loader containerClassName="" />
                                </div>
                            ) : null}
                        </ModalBody>
                    </Modal>
                </Col>
            </Row>

        </Strip>
    )
}

export default AddTool;